import { call, put } from "redux-saga/effects";
import { AdminProfileResponse } from "reduxStore/dataTypes";
import { fetchAdminProfile } from "services/apiService";
import {
  adminProfileFailure,
  adminProfileRequest,
  adminProfileSuccess,
} from "../reducers/adminProfileReducer";

function* adminProfileSaga(): Generator<any, void, AdminProfileResponse | any> {
  try {
    yield put(adminProfileRequest());
    const response = yield call(fetchAdminProfile);
    yield put(adminProfileSuccess(response.data));
  } catch (error: any) {
    if (error && error.response) {
      yield put(adminProfileFailure(error.response));
    } else {
      yield put(adminProfileFailure(error.message));
    }
  }
}

export default adminProfileSaga;
